"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.answerRoutes = void 0;
exports.answerRoutes = [
    {
        name: 'answer.list',
        path: ['/', '/q/:q'],
        method: 'GET'
    },
    {
        name: 'answer.create',
        path: ['/'],
        method: 'POST'
    },
    {
        name: 'answer.get',
        path: '/:id',
        method: 'GET'
    },
    {
        name: 'answer.update',
        path: '/:id',
        method: 'PUT'
    },
    {
        name: 'answer.delete',
        path: '/:id',
        method: 'DELETE'
    }
];
